import { supabase } from "@lib/supabase/client";

export async function signOutUser(redirectTo = "/"): Promise<void> {
  try {
    await supabase.auth.signOut({ scope: "local" });
  } catch {
    /* ignored — local auth state is cleared unconditionally below */
  }
  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith("sb-"))
      .forEach((key) => localStorage.removeItem(key));
  } catch {
    /* ignored */
  }
  window.location.assign(redirectTo);
}
